require("./modules/tooltip.js");

var outputs = {};

var inputs = {};
$(document).ready(function(){


	$("#CalcButton").on("click",calculate)
	$("#CalcButtonTime").on("click",calculateTime)


	//$(".tooltip-icon").attr("aria-expanded","false");
	

	//$(".tooltip-text").on("blur keydown",tooltipBlur)

	
	

});







function calculate(event){
	event.preventDefault();
	

	$(".error").addClass("hidden");
	

	var data = getInputs(".inputs input");
	inputs = data.inputs;

	if(data.errList.length > 0){
		data.errList[0].input.focus();
		return;
	}

	//console.log(inputs);

	$(".outputs").removeClass("hidden");
	//(Arbeitstage / 100% * Arbeitspensum = Arbeitstage pro Jahr)

	
	outputs.WorkdaysPerYear = inputs.WorkdaysPerYear * inputs.WorkPercent / 100;
	//(Km pro Weg * 2 (=KM pro Tag) * 0.65chf/km = Kosten Pro Tag)
	outputs.CarCostsPerDay = inputs.KmPerWay * 2 * inputs.TcsPricePerKm;

	//Kosten Arbeitsweg pro Monat
    //Auto:  W8 * W7 / 12 + W4 = W9 (Kosten pro Tag * Arbeitstage pro Jahr / 12 + Parkplatzkosten = Kosten pro Monat)
    //ÖV: W3 / 12 = W10 (ÖV Kosten / 12 = Kosten pro Monat)

	outputs.CarCostsPerMonth = outputs.CarCostsPerDay * (outputs.WorkdaysPerYear / 12) + inputs.ParkingPerMonth;

	outputs.PubTransPerMonth = inputs.YearSubscription / 12;



    //Kosten Arbeitsweg pro Jahr
    //Auto: W8 * W7 + (W4 * 12) = W11 (Kosten pro Tag * Arbeitstage pro Jahr + Parkplatzkosten pro Jahr)
    //ÖV: W3

    outputs.CarCostsPerYear = (outputs.CarCostsPerDay * outputs.WorkdaysPerYear) + (inputs.ParkingPerMonth * 12);

    outputs.PubTransPerYear = inputs.YearSubscription;


    //Einsparungen ÖV gegenüber Auto
    //Pro Monat: W9 – W10 (Autokosten – ÖV Kosten)
    //Pro Jahr:  W11 – W3 (Autokosten – ÖV Kosten)

    outputs.CarSavingsPerMonth = outputs.CarCostsPerMonth - outputs.PubTransPerMonth;
    outputs.CarSavingsPerYear = outputs.CarCostsPerYear - outputs.PubTransPerYear;

    
    outputs.TotalKm = outputs.WorkdaysPerYear * 2 * inputs.KmPerWay;



    outputs.SavingsCo2PerYear = outputs.TotalKm / 5.1 - outputs.TotalKm / 328.3;
    outputs.FuelLitres = outputs.TotalKm / 10.4 - outputs.TotalKm / 113.8;
    outputs.FuelTanks = outputs.FuelLitres / 60;


/*

function processAndWriteResults() {
			numberWorkingDaysPerYear = 220.0*jQuery("#input2").val()/100.0;
			if (numberWorkingDaysPerYear == 0.0) numberWorkingDaysPerYear++;
			var resultCostsCarPerYear = Math.round((jQuery("#input1").val()*2*0.65*numberWorkingDaysPerYear + 12*jQuery("#input4").val()));  // formula from Excel sheet translated to JS
			jQuery("#costscarperyear").text(resultCostsCarPerYear);
			jQuery("#costscarpermonth").text(Math.round(resultCostsCarPerYear/12.0));
			jQuery("#costsoevperyear").text(Math.round(jQuery("#input3").val()));
			jQuery("#costsoevpermonth").text(Math.round(jQuery("#input3").val()/12.0));
			
			var tmpResultSavingsCarPerYear = jQuery("#input1").val()*2*numberWorkingDaysPerYear;
			var resultSavingsCarPerYear = Math.round(tmpResultSavingsCarPerYear/5.1 - tmpResultSavingsCarPerYear/328.3);
			jQuery("#savingscarpermonth").text(jQuery("#costscarpermonth").text() - jQuery("#costsoevpermonth").text());
			jQuery("#savingscarperyear").text(jQuery("#costscarperyear").text() - jQuery("#costsoevperyear").text());
			jQuery("#savingsco2peryear").text(resultSavingsCarPerYear);
			jQuery("#savingsfuelperyear").text(Math.round((tmpResultSavingsCarPerYear/10.4 - tmpResultSavingsCarPerYear/113.8)/60.0));
			
			showSliderValue(currentChosenIncome); 
			showDivs();
		}
*/
    


    
	applyOutput(outputs);

	//console.log(outputs);

	$("#CalcButtonFocus").attr("tabindex","0").focus();

}

function getInputs(selector){
	var data = {
		inputs:[]
	};
	var errList = [];


	$(selector).each(function(){
		var iRef = $(this);
		var id = iRef.attr("id");
		var val = iRef.val();
		var valNum = parseFloat(val);		

		if(isNaN(valNum) || String(val) != String(valNum)){
			var errRef = iRef.closest(".input").find(".error");
			errRef.attr("id",id+"-error");
			iRef.attr("aria-invalid","true");
			iRef.attr("aria-describedby",id+"-error");
			errRef.removeClass("hidden");
			iRef.focus();
			errList.push({input:iRef,error:errRef});
		}else{
			iRef.attr("aria-invalid","false");
			iRef.removeAttr("aria-describedby");
			data.inputs[id] = valNum;	
		}		
	});
	data.errList = errList;
	return data;
}

function applyOutput(outputs){
	for (var i in outputs){
    	var value = outputs[i];
    	if(isNaN(value)){
    		value = 0;
    	}
    	var roundedValue = Math.round(value);
    	var ref = $(".output-"+i);

    	ref.html(roundedValue);

    	ref = $(".output-formatted-"+i);

    	//console.log(numberWithCommas(roundedValue));
    	ref.html(numberWithCommas(roundedValue));
    }
}


function calculateTime(){
	//outputs.TakeHomeSalary

	var data = getInputs(".outputs input");

	

	outputs.CarWorkTimePerDay = outputs.CarCostsPerYear / outputs.WorkdaysPerYear / data.inputs.TakeHomePayPerMonth * 10000;
	outputs.PubTransWorkTimePerDay =  outputs.PubTransPerYear / outputs.WorkdaysPerYear / data.inputs.TakeHomePayPerMonth * 10000;

	//console.log(outputs);


	applyOutput(outputs);


	$("#timeresults").removeClass("hidden");

	setTimeout(function(){
		$("#calculateTimeFocus").attr("tabindex","0").focus();
	},100);


	
}


const numberWithCommas = (x) => {
  return x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, "'")+".00";
}


/*

jQuery("#workingtimeneededforcar").text(Math.round(jQuery("#costscarperyear").text() / numberWorkingDaysPerYear / jQuery("#salarypermonth").text() * 10000.0));
			jQuery("#workingtimeneededforoev").text(Math.round(jQuery("#costsoevperyear").text()/numberWorkingDaysPerYear/jQuery("#salarypermonth").text() * 10000.0));
*/


// WEBPACK FOOTER //
// ./Frontend/js/app.js